export default {
	accountShareHoldings: state => {
		return state.accountShareHoldings
	},
	cashBalance: state => {
		return state.cashBalance
	},
	tradingHours: state => state.tradingHours
}
